import { z } from 'zod';

const CropSettingsSchema = z.object({
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
  scale: z.number(),
  originalWidth: z.number(),
  originalHeight: z.number(),
});

const cropSettingsMapSchema = z.record(z.string(), CropSettingsSchema);

const ImageSchema = z.object({
  alt: z.string().optional(),
  originalUrl: z.string().trim().min(1),
  cropSettings: cropSettingsMapSchema.optional(),
});

const OptionalImageSchema = z
  .object({
    alt: z.string().optional(),
    originalUrl: z.string(),
    cropSettings: cropSettingsMapSchema.optional(),
  })
  .optional();

export { CropSettingsSchema, cropSettingsMapSchema, ImageSchema, OptionalImageSchema };
